<div class="spinner-container" *ngIf="loading">
  <div class="spinner"></div>
  <div class="progress-bar"></div>
</div>
